<template>
    <!-- basic map -->
    <div class="col-lg-12">
        <button @click="geocodedAddress">click</button>
        {{address}}
        <gmap-map ref="mymap" :center="{ lat: 2, lng: 2 }" :zoom="5" style="height: 80vh">
            <gmap-marker
            :position="google && new google.maps.LatLng(1.38, 103.8)"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'

export default {
    data() {
        return {
            markers: [
                {
                    position: { lat: 10.0, lng: 10.0 }
                },
                {
                    position: { lat: 15.0, lng: 13.0 }
                }
            ],
        }
    },
    props: {
        address : String,
        openMap : Boolean
    },
    computed:{
        google: gmapApi,
        // geocoder : new google.maps.Geocoder()
    },
    watch: { 
        address: {
            handler: function(n, o) {
                console.log(JSON.stringify(n));
                this.count1 = n.count;
            },
            deep: true  
        }
    },
    methods: {
        geocodedAddress(){
            const geocoder = this.google && new google.maps.Geocoder();
            geocoder.geocode( { 'address' : this.address }, function( results, status ) {
                // if( status == google.maps.GeocoderStatus.OK ) {
                    console.log('geocode->',results[0].geometry.location.lat());
                    //In this case it creates a marker, but you can get the lat and lng from the location.LatLng
                    // map.setCenter( results[0].geometry.location );
                    // var marker = new google.maps.Marker( {
                    //     map     : map,
                    //     position: results[0].geometry.location
                    // } );
                // } else {
                //     alert( 'Geocode was not successful for the following reason: ' + status );
                // }
            } );
        }
    }, 
    mounted(){
        this.$watch(()=>this.openMap, () => {
            if (this.openMap == true) {
                console.log(this.latlong);
                this.geocodedAddress();
            }
        })
    }
};
</script>